export const PROGRAM_INDENT_MAP: Record<string, string[]> = {

  'mosaic': ['businessStream'],  
  'ibp': ['gdo', 'program_job_name'],               
  'edf': ['productShortName', 'dataAssetName', 'bronzeTableName', 'silverTableName'],  
};

export const LAYER_DEPENDENT_FIELDS = {
  
  'gold': ['goldTableName', 'scheduleInfo', 'sourceTables', 'pecNonPec', 'mecNonMec'],
  'silver': ['dataAssetName', 'bronzeTableName', 'silverTableName']
};

export const ALL_PROGRAM_FIELDS = [
  'businessStream', 'gdo', 'dataAssetName', 
  'bronzeTableName', 'silverTableName', 'goldTableName',
  'scheduleInfo', 'sourceTables', 'pecNonPec', 'mecNonMec', 'layer'
];

export const moreFilterFields = ['scheduleCategory', 'scheduledForNext', 'sourceCategory', 'sourceType', 'sourceSubcategory', 'orchestratorScheduler', 'dataAssetName', 'department', 'capability', 'technology', 'subscriptionName', 'resourceGroup', 'resourceName', 'sustainOwner', 'sustainProdDate'];

export const defaultFields = ['program', 'domain', 'sector', 'market', 'jobType', 'businessUnit', 'appName', 'miscellaneousSectors'];
